import { render, staticRenderFns } from "./FilesSingleAssistance.vue?vue&type=template&id=31ded1c5&"
import script from "./FilesSingleAssistance.vue?vue&type=script&lang=js&"
export * from "./FilesSingleAssistance.vue?vue&type=script&lang=js&"
import style0 from "./FilesSingleAssistance.vue?vue&type=style&index=0&id=31ded1c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports